<template>
    <div>
        <slot />

        <div class="card">
            <div class="card-header">
                <div class="card-header-title">
                    <div class="media">
                        <div class="media-left">
                            <e-skeleton width="200px" :active="active" />
                        </div>

                        <div class="media-right">
                            <e-skeleton width="100px" :active="active" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="content.display" class="card-content">
                <div class="content">
                    <e-skeleton size="is-large" :active="active" :height="content.height" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SkeletonCard',

    props: {
        active: {
            required: true,
            type: Boolean,
        },

        content: {
            default: () => ({ display: true, height: '20px' }),
            type: Object,
        },
    },
};
</script>
